import { SigningIn } from '../topics/SigningIn';
import { SingleSignOn } from '../topics/SingleSignOn';
import { ManagingAccounts } from '../topics/ManagingAccounts';
import { ResetPassword } from '../topics/ResetPassword';
import { ChangePassword } from '../topics/ChangePassword';
import { SignInProfiles } from '../topics/SignInProfiles';
import { Applications } from '../topics/Applications';
import { UserAgreements } from '../topics/UserAgreements';
import { Troubleshooting } from '../topics/Troubleshooting';

const topicComponents: Record<string, React.FC> = {
    'signing-in': SigningIn,
    'single-sign-on': SingleSignOn,
    'managing-accounts': ManagingAccounts,
    'reset-password': ResetPassword,
    'change-password': ChangePassword,
    'sign-in-profiles': SignInProfiles,
    'applications': Applications,
    'user-agreements': UserAgreements,
    'troubleshooting': Troubleshooting,
};

export const DocumentationContent = ({ activeTopic }: { activeTopic: string }) => {
    const TopicComponent = topicComponents[activeTopic];

    if (!TopicComponent) {
        return null;
    }

    return <TopicComponent />;
};
